enum ProfileUrlParamKey {
  CreateAirdrop = "createAirdrop",
  CreateSeries = "createSeries",
  Tab = "tab",
}

export default ProfileUrlParamKey;
